import { SyncOff } from 'assets/icons/SyncOff';
import { SyncOn } from 'assets/icons/SyncOn';
import InlineLoader from 'common/components/InlineLoader';
import SimpleSwitch from 'offers/components/SimpleSwitch';
import React from 'react';

const AutoSyncSwitch = ({
  isAutoSyncActive,
  setAutoSyncActive,
  isAutoSyncChanging,
  isAutoSyncDisabled,
}) => {
  const handleToggle = () => {
    if (isAutoSyncDisabled) return;
    const nextSyncState = !isAutoSyncActive;
    setAutoSyncActive(nextSyncState);
  };

  return (
    <div className='flex items-center gap-1'>
      <SimpleSwitch
        isActive={isAutoSyncActive}
        isDisabled={isAutoSyncDisabled}
        onToggle={handleToggle}
      />

      {isAutoSyncChanging ? (
        <InlineLoader size={16} />
      ) : isAutoSyncActive ? (
        <SyncOn size={16} color='#F16347' />
      ) : (
        <SyncOff size={16} color='#8D91A0' />
      )}
    </div>
  );
};

export default AutoSyncSwitch;
